// noinspection JSUnusedGlobalSymbols
import { createRoot, createElement } from '@wordpress/element';
import Dashboard from './src/index';
import './src/scss/style.scss';
window.addEventListener('load', function () {
    var data = document.querySelector('.ultrablocks-admin-page');
    if (data) {
        createRoot(data).render(createElement(Dashboard));
    }
});
